import React from 'react';
import { Globe, Lock, ShieldCheck, Info, Home } from 'lucide-react';

const YoutubeSettings = ({ settings, onSettingsChange }) => {
    const maxLength = 100;
    const currentLength = settings.title?.length || 0;

    const handleTitleChange = (e) => {
        if (e.target.value.length <= maxLength) {
            onSettingsChange({ ...settings, title: e.target.value });
        }
    };

    return (
        <div className="w-full bg-white border border-gray-200 rounded-2xl p-6 shadow-sm font-sans">
            <h3 className="text-sm font-black text-gray-800 uppercase tracking-wider mb-6 flex items-center gap-2">
                <ShieldCheck size={18} className="text-red-600" />
                YouTube Posting Settings
            </h3>

            <div className="space-y-6">
                {/* 🌟 New: Video Title - 视频标题设置 */}
                <div className="space-y-2">
                    <div className="flex items-center justify-between">
                        <label className="text-[10px] font-black text-gray-400 uppercase tracking-widest flex items-center gap-1.5">
                            <Home size={12} className="text-gray-400" />
                            Video Title
                        </label>
                        {/* 0/100 动态字数提醒 */}
                        <span
                            className={`text-[10px] font-mono font-black ${currentLength >= 90 ? 'text-red-600 animate-pulse' : 'text-gray-400'
                                }`}
                        >
                            {currentLength} / {maxLength}
                        </span>
                    </div>
                    <div className="relative rounded-xl shadow-sm">
                        <input
                            type="text"
                            value={settings.title || ''}
                            onChange={handleTitleChange}
                            placeholder="Enter a catchy title (Required for YouTube)..."
                            className="block w-full rounded-xl border-gray-200 py-3 px-4 text-xs font-bold text-gray-800 placeholder-gray-400 focus:border-red-500 focus:ring-red-500 bg-gray-50/50"
                        />
                    </div>
                </div>

                {/* 1. Privacy Status - 隐私设置 */}
                <div className="space-y-2">
                    <label className="text-[10px] font-black text-gray-400 uppercase tracking-widest">Privacy Status</label>
                    <div className="grid grid-cols-2 gap-3">
                        <button
                            onClick={() => onSettingsChange({ ...settings, privacy: 'public' })}
                            className={`flex items-center justify-center gap-2 py-3 px-4 rounded-xl border-2 transition-all ${settings.privacy === 'public' ? 'border-red-600 bg-red-50 text-red-700' : 'border-gray-100 bg-gray-50 text-gray-500'}`}
                        >
                            <Globe size={14} />
                            <span className="text-xs font-bold">Public</span>
                        </button>
                        <button
                            onClick={() => onSettingsChange({ ...settings, privacy: 'private' })}
                            className={`flex items-center justify-center gap-2 py-3 px-4 rounded-xl border-2 transition-all ${settings.privacy === 'private' ? 'border-red-600 bg-red-50 text-red-700' : 'border-gray-100 bg-gray-50 text-gray-500'}`}
                        >
                            <Lock size={14} />
                            <span className="text-xs font-bold">Private</span>
                        </button>
                    </div>
                </div>

                {/* 3. COPPA Compliance - 儿童内容声明 (审核必看) */}
                <div className={`p-4 rounded-2xl border-2 transition-all ${settings.for_kids ? 'bg-red-50 border-red-200' : 'bg-gray-50 border-transparent'}`}>
                    <div className="flex items-start justify-between">
                        <div className="pr-4">
                            <span className="text-[11px] font-black text-gray-800 uppercase tracking-tighter flex items-center gap-1">
                                Made for Kids
                                <Info size={12} className="text-red-500" />
                            </span>
                            <p className="text-[9px] text-gray-500 mt-1 leading-relaxed">
                                Required: Let us know if this video is directed to children (COPPA).
                            </p>
                        </div>
                        <button
                            onClick={() => onSettingsChange({ ...settings, for_kids: !settings.for_kids })}
                            className={`w-10 h-6 rounded-full relative transition-colors flex-none ${settings.for_kids ? 'bg-red-500' : 'bg-gray-300'}`}
                        >
                            <div className={`absolute top-1 w-4 h-4 bg-white rounded-full shadow-sm transition-all ${settings.for_kids ? 'left-5' : 'left-1'}`} />
                        </button>
                    </div>
                </div>

                {/* 4. Submission Hint - 合规提示 */}
                <div className="pt-2">
                    <p className="text-[10px] text-gray-400 text-center leading-normal">
                        By publishing, you confirm your video complies with
                        <a href="https://www.youtube.com/t/terms" target="_blank" rel="noreferrer" className="text-gray-600 font-bold hover:underline mx-1">YouTube Terms</a>
                        and
                        <a href="https://www.youtube.com/howyoutubeworks/our-policies/" target="_blank" rel="noreferrer" className="text-gray-600 font-bold hover:underline mx-1">Community Guidelines</a>.
                    </p>
                </div>
            </div>
        </div>
    );
};

export default YoutubeSettings;